import React, { FC } from 'react';

import Loader from '../../../components/loader/index';
import { PaginationController } from '../../../components/pagination-controller/index';
import { Pool } from '../../../hooks/index';
import { PageRoute } from '../../../types/page.types';
import { PoolPlansTab } from '../../../types/pool-plans.types';
import { EmptyPools } from '../empty-pools';
import { PoolCard } from './cards/pool-card';

type PoolPlansMobileProps = {
  companyId: string;
  currentPage: number;
  date: Date;
  handlePageChange: (page: number) => void;
  selectedTab: PoolPlansTab;
};

export const PoolPlansMobile: FC<PoolPlansMobileProps> = ({
  companyId,
  selectedTab,
  currentPage,
  handlePageChange,
  date,
}) => {
  const numberOfFetchedItems = 5;
  const { pools, totalPages, isLoading } = Pool.usePools({
    companyId,
    currentPage,
    take: Number(numberOfFetchedItems),
    vestByDate: date,
  });
  const {
    pools: terminatedPools,
    totalPages: terminatedTotalPages,
    isLoading: isTerminatedLoading,
  } = Pool.useTerminatedPools({
    companyId,
    currentPage,
    take: Number(numberOfFetchedItems),
  });

  const currentPagePools = selectedTab === PoolPlansTab.ACTIVE ? pools : terminatedPools;

  if (!pools || isLoading || !terminatedPools || isTerminatedLoading) return <Loader />;

  return (
    <>
      {currentPagePools && currentPagePools.length > 0 ? (
        <>
          <div className="flex min-h-full flex-col items-center p-[1px]">
            {currentPagePools?.map((pool) => (
              <PoolCard
                key={pool.id}
                navigationLink={`${PageRoute.POOL_PLANS}/${pool.id}`}
                pool={pool}
              />
            ))}
          </div>
          <PaginationController
            className="shrink-0 max-lg:px-4 lg:mx-6"
            currentPage={currentPage}
            onClick={handlePageChange}
            totalPages={
              selectedTab === PoolPlansTab.ACTIVE ? totalPages || 0 : terminatedTotalPages || 0
            }
          />
        </>
      ) : (
        <EmptyPools isMobile selectedTab={selectedTab} />
      )}
    </>
  );
};
